<div id="unauthorized-page-container">
    <div id="text-container">
        <h1 class="title">Serving research. Saving confidential data.</h1>

        <div class="content">
            <p>We can automate genotyping, but not page permissions.</p>
            <p class="small-width">
                if you feel like you have reached this in error,<br />
                contact our Genetic Services team will be happy to assist you at <br />
                <a href="mailto: help@transnetyx.com" class="link">{{ 'help@transnetyx.com' }}</a> or call
                <a href="tel: 888-321-2113" class="link">888-321-2113</a>.
            </p>
        </div>

        <div class="action-buttons">
            <button
                id="error-page-sign-out-btn"
                pButton
                type="button"
                class="p-button"
                [label]="'Sign Out'"
                (click)="logout()"></button>
            <button
                id="live-chat-btn"
                pButton
                type="button"
                icon="far fa-comments"
                class="p-button-outlined"
                [label]="'Go to Dashboard'"
                (click)="goToDashboard()"></button>
        </div>
    </div>

    <div id="image-container">
        <img src="assets/error_403.svg" alt="server-error-image" />
    </div>
</div>
